import React, { useState, useEffect } from 'react';
import {
  BookOpen,
  Hash,
  Calendar,
  Plus,
  Save,
  X,
  // Edit2,
  Trash2,
  Eye,
  Upload,
  //   FileText,
  User,
  FileText,
  ChevronDown,
  ChevronUp,
  Download,
  CheckCircle,
  AlertCircle,
  Loader2
} from 'lucide-react';
import './JournalVolume.css';
import { ApiUrl, BaseUrl } from '../API/ApiUrl';
import Swal from 'sweetalert2';
import Toast from "../components/Toast/Toast";

const JournalVolume = () => {
  // Main Volume State
  const [volumes, setVolumes] = useState([]);

  // Form States
  const [showVolumeForm, setShowVolumeForm] = useState(false);
  const [showIssueForm, setShowIssueForm] = useState(false);
  const [showArticleForm, setShowArticleForm] = useState(false);
  const [showArticleModal, setShowArticleModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [expandedVolume, setExpandedVolume] = useState(null);
  const [expandedIssue, setExpandedIssue] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [saving, setSaving] = useState(false);

  // Form Data
  const [volumeForm, setVolumeForm] = useState({
    volume: '',
    year: ''
  });

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success"
  });

  const currentDate = new Date();

  const [issueForm, setIssueForm] = useState({
    issue: "",
    month: currentDate.toLocaleString("default", { month: "long" }),
    year: currentDate.getFullYear()
  });


  const [articleForm, setArticleForm] = useState({
    topic: '',
    pages: '',
    author: '',
    file: null
  });

  const [currentVolumeId, setCurrentVolumeId] = useState(null);
  const [currentIssueId, setCurrentIssueId] = useState(null);
  // const [editingMode, setEditingMode] = useState(false);

  const handleVolumeInputChange = (e) => {
    const { name, value } = e.target;

    const numericValue = value.replace(/[^0-9]/g, "");

    setVolumeForm({
      ...volumeForm,
      [name]: numericValue
    });
  };

  useEffect(() => {
    fetchVolumes();
  }, []);

  const fetchVolumes = async () => {
    try {

      // const token = localStorage.getItem("adminToken");

      const res = await fetch(`${ApiUrl}/journal-volumes`);

      const data = await res.json();
      console.log("Volumes from API:", data);

      setVolumes(data);

    } catch (err) {
      console.error(err);
    }
  };

  const handleVolumeSubmit = async (e) => {
    e.preventDefault();

    if (!volumeForm.volume || !volumeForm.year) {
      // setErrorMessage("Please fill in all fields");
      setToast({
        show: true,
        message: "Please enter volume number",
        type: "error"
      });
      setTimeout(() => {
        setToast("");
      }, 3000); // clears after 3 seconds

      return;
    }

    setSaving(true)

    try {

      const token = localStorage.getItem("adminToken");

      const res = await fetch(`${ApiUrl}/journal-volumes/volume`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(volumeForm)
      });
      const data = await res.json();


      //  HANDLE ERROR FROM BACKEND
      if (!res.ok) {
        setToast({
          show: true,
          message: data.message || "Something went wrong",
          type: "error"
        });

        setTimeout(() => setToast(""), 3000);
        return;
      }

      //  SUCCESS
      fetchVolumes();
      setVolumeForm({ volume: "", year: "" });
      setShowVolumeForm(false);

      setToast({
        show: true,
        message: data.message || "Volume added successfully",
        type: "success"
      });

      setTimeout(() => setToast(""), 3000);


    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false)
    }
  };

  const handleIssueInputChange = (e) => {
    const { name, value } = e.target;
    const currentDate = new Date();

    setIssueForm((prev) => {
      if (name === "issue") {
        const numericValue = value.replace(/[^0-9]/g, "");
        return {
          ...prev,
          issue: numericValue
        };
      }

      if (name === "month") {
        return {
          ...prev,
          month:
            value ||
            currentDate.toLocaleString("default", { month: "long" })
        };
      }

      if (name === "year") {
        return {
          ...prev,
          year: value || currentDate.getFullYear()
        };
      }

      return {
        ...prev,
        [name]: value
      };
    });
  };


  const handleIssueSubmit = async (volumeId) => {

    // console.log("Clicked Volume ID:", volumeId);
    // console.log("Issue Form Data:", issueForm);

    if (!issueForm.issue) {
      // setErrorMessage("Please enter issue number");
      setToast({
        show: true,
        message: "Please enter issue number",
        type: "error"
      });
      setTimeout(() => {
        setToast("");
      }, 3000); // clears after 3 seconds

      return;
    }

    const payload = {
      volume_id: volumeId,
      issue: issueForm.issue,
      month_year: `${issueForm.month}/${issueForm.year}`
    };

    console.log("Sending Payload:", payload);

    setSaving(true)

    try {

      const token = localStorage.getItem("adminToken");

      const res = await fetch(`${ApiUrl}/journal-volumes/issue`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json();

      console.log("API Response:", data);

      if (res.ok) {
        fetchVolumes();
        setIssueForm({
          issue: "",
          month: currentDate.toLocaleString("default", { month: "long" }),
          year: currentDate.getFullYear()
        });
        setShowIssueForm(false);
        setCurrentVolumeId(null);
        setSuccessMessage(data.message || "Issue added successfully");

        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      }

    } catch (err) {
      console.error("Issue Submit Error:", err);
    } finally {
      setSaving(false)
    }
  };

  // Handle Article Form
  const handleArticleInputChange = (e) => {
    const { name, value } = e.target;
    setArticleForm({
      ...articleForm,
      [name]: value
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setArticleForm({
        ...articleForm,
        file: file
      });
    }
  };

  const validateArticleForm = () => {
    const { topic, pages, author } = articleForm;

    if (!topic || !topic.trim()) {
      setToast({
        show: true,
        message: "Topic is required",
        type: "error"
      });
      return false;
    }

    if (!pages || !pages.trim()) {
      setToast({
        show: true,
        message: "Pages is required",
        type: "error"
      });
      return false;
    }

    if (!author || !author.trim()) {
      setToast({
        show: true,
        message: "Author name is required",
        type: "error"
      });
      return false;
    }

    if (!selectedFile) {
      setToast({
        show: true,
        message: "Please upload article file",
        type: "error"
      });
      return false;
    }

    // Topic
    if (!topic || topic.trim().length < 3) {
      setToast({
        show: true,
        message: "Topic must be at least 3 characters",
        type: "error"
      });
      return false;
    }

    // Pages → number or range
    const pagesRegex = /^\d+(-\d+)?$/;

    if (!pagesRegex.test(pages)) {
      setToast({
        show: true,
        message: "Pages must be like 12 or 12-18",
        type: "error"
      });
      return false;
    }

    // Author
    const authorRegex = /^[A-Za-z\s]+$/;

    if (!authorRegex.test(author)) {
      setToast({
        show: true,
        message: "Author name should contain only letters",
        type: "error"
      });
      return false;
    }

    // File required
    if (!selectedFile) {
      setToast({
        show: true,
        message: "Please upload article file",
        type: "error"
      });
      return false;
    }

    // File type
    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      setToast({
        show: true,
        message: "Only PDF, DOC, DOCX files are allowed",
        type: "error"
      });
      return false;
    }

    return true;
  };


  const handleArticleSubmit = async (volumeId, issueId) => {

    if (!validateArticleForm()) {
      setTimeout(() => setErrorMessage(""), 3000);
      return;
    }


    const formData = new FormData();

    formData.append("volume_id", volumeId);
    formData.append("issue_id", issueId);
    formData.append("topic", articleForm.topic);
    formData.append("pages", articleForm.pages);
    formData.append("author", articleForm.author);

    if (selectedFile) {
      formData.append("file", selectedFile);
    }

    setSaving(true)

    try {

      const token = localStorage.getItem("adminToken");

      const res = await fetch(`${ApiUrl}/journal-volumes/article`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData
      });
      const data = await res.json();


      if (res.ok) {
        fetchVolumes();

        setArticleForm({
          topic: "",
          pages: "",
          author: ""
        });

        setSelectedFile(null);
        setShowArticleForm(false);
        setSuccessMessage(data.message || "Article added successfully");

        setTimeout(() => {
          setSuccessMessage("");
        }, 3000);
      }

    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false)
    }
  };

  const handleDeleteVolume = async (volumeId) => {

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This will delete the volume and all related issues/articles.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    });
    if (!result.isConfirmed) return;


    try {

      const token = localStorage.getItem("adminToken");

      await fetch(`${ApiUrl}/journal-volumes/volume/${volumeId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      fetchVolumes();

    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteIssue = async (volumeId, issueId) => {

    const result = await Swal.fire({
      title: "Delete this issue?",
      text: "All related articles will be removed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!"
    });

    if (!result.isConfirmed) return;

    try {

      const token = localStorage.getItem("adminToken");

      await fetch(`${ApiUrl}/journal-volumes/issue/${issueId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      fetchVolumes();

    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteArticle = async (volumeId, issueId, articleId) => {

    const result = await Swal.fire({
      title: "Delete this article?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!"
    });

    if (!result.isConfirmed) return;

    try {

      const token = localStorage.getItem("adminToken");

      await fetch(`${ApiUrl}/journal-volumes/article/${articleId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      fetchVolumes();

    } catch (err) {
      console.error(err);
    }
  };

  // Handle View
  const handleViewArticle = (article) => {
    // window.open(`${ApiUrl}${article.file_path}`, "_blank");

    setSelectedArticle(article);
    setShowArticleModal(true);
  };

  // Toggle Expand
  const toggleVolume = (volumeId) => {
    setExpandedVolume(expandedVolume === volumeId ? null : volumeId);
  };

  // const toggleIssue = (issueId) => {
  //   setExpandedIssue(expandedIssue === issueId ? null : issueId);
  // };

  const handleDownloadFiles = (files) => {
    if (files) {
      window.open(`${BaseUrl}/uploads/${files}`, '_blank');
    }
  };

  const currentYear = new Date().getFullYear();

  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  return (
    <div className="journal-volume-page">
      {/* Header */}
      <div className="page-header">
        <div className="title-section">
          <BookOpen size={24} className="title-icon" />
          <div>
            <h1 className="page-title">Journal Volumes</h1>
            <p className="page-subtitle">Manage volumes, issues, and articles</p>
          </div>
        </div>

        {!showVolumeForm && (
          <button className="btn-primary" onClick={() => setShowVolumeForm(true)}>
            <Plus size={16} />
            <span>Add New Volume</span>
          </button>
        )}
      </div>

      {/* Success/Error Messages */}
      {successMessage && (
        <div className="alert success">
          <CheckCircle size={16} />
          <span>{successMessage}</span>
        </div>
      )}

      {errorMessage && (
        <div className="alert error">
          <AlertCircle size={16} />
          <span>{errorMessage}</span>
        </div>
      )}

      {showVolumeForm && (
        <div className="form-card">
          <div className="form-header">
            <h3>Add New Volume</h3>
            <button className="btn-icon" onClick={() => setShowVolumeForm(false)}>
              <X size={16} />
            </button>
          </div>

          <form onSubmit={handleVolumeSubmit} className="volume-form">
            <div className="form-row">
              <div className="form-group">
                <label>
                  <Hash size={14} />
                  <span>Volume Number</span>
                </label>
                <input
                  type="text"
                  name="volume"
                  value={volumeForm.volume}
                  onChange={handleVolumeInputChange}
                  placeholder="e.g., 1, 2, 3"
                />
              </div>

              <div className="form-group">
                <label>
                  <Calendar size={14} />
                  <span>Year</span>
                </label>
                <select
                  name="year"
                  value={volumeForm.year}
                  onChange={handleVolumeInputChange}
                  className="form-select"
                  required
                >
                  <option value="">Select Year</option>

                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" disabled={saving} onClick={() => setShowVolumeForm(false)}>
                Cancel
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                {/* <Save size={14} /> */}
                {saving ? (
                  <>
                    <Loader2 size={16} className="spin-icon" />
                    <span>Saving...</span>
                  </>
                ) : (
                  <>
                    <Save size={16} />
                    <span>Save Volume</span>
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      )}


      <div className="volumes-container">
        {volumes.map((volume) => (
          <div key={volume.id} className="volume-card">
            <div className="volume-header" onClick={() => toggleVolume(volume.id)}>
              <div className="volume-title">
                <BookOpen size={20} className="volume-icon" />
                <div>
                  <h3>Volume {volume.volume}</h3>
                  <span className="volume-year">Year: {volume.year}</span>
                </div>
              </div>
              <div className="volume-actions">
                <span className="issue-count">{volume.issues?.length || 0} Issues</span>
                <button
                  className="delete-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteVolume(volume.id);
                  }}
                >
                  <Trash2 size={16} />
                </button>
                {expandedVolume === volume.id ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
              </div>
            </div>

            {expandedVolume === volume.id && (
              <div className="volume-content">
                {/* Add Issue Button */}
                {!showIssueForm && (
                  <button
                    className="btn-add-issue"
                    onClick={() => {
                      setCurrentVolumeId(volume.id);
                      setShowIssueForm(true);
                    }}
                  >
                    <Plus size={14} />
                    <span>Add Issue</span>
                  </button>
                )}

                {showIssueForm && currentVolumeId === volume.id && (
                  <div className="issue-form-card">
                    <div className="form-header">
                      <h4>Add New Issue to Volume {volume.volume}</h4>
                      <button
                        className="btn-icon"
                        onClick={() => {
                          setShowIssueForm(false);
                          setCurrentVolumeId(null);
                        }}
                      >
                        <X size={14} />
                      </button>
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>
                          <Hash size={12} />
                          <span>Issue Number <span className="required">*</span></span>
                        </label>
                        <input
                          type="text"
                          name="issue"
                          value={issueForm.issue}
                          onChange={handleIssueInputChange}
                          placeholder="e.g., 1, 2"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>
                          <Calendar size={12} />
                          <span>Month</span>
                        </label>

                        <select
                          name="month"
                          value={issueForm.month}
                          onChange={handleIssueInputChange}
                        >
                          {[
                            "January", "February", "March", "April", "May", "June",
                            "July", "August", "September", "October", "November", "December"
                          ].map((month) => (
                            <option key={month} value={month}>
                              {month}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>
                          <Calendar size={12} />
                          <span>Year</span>
                        </label>

                        <select
                          name="year"
                          value={issueForm.year}
                          onChange={handleIssueInputChange}
                        >
                          {Array.from({ length: 11 }, (_, i) => {
                            const year = new Date().getFullYear() - 10 + i;
                            return (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div className="form-actions">
                      <button
                        className="btn-secondary"
                        onClick={() => {
                          setShowIssueForm(false);
                          setCurrentVolumeId(null);
                        }}
                        disabled={saving}

                      >
                        Cancel
                      </button>
                      <button
                        className="btn-primary"
                        onClick={() => handleIssueSubmit(volume.id)}
                        disabled={saving}
                      >
                        {saving ? (
                          <>
                            <Loader2 size={16} className="spin-icon" />
                            <span>Saving...</span>
                          </>
                        ) : (
                          <>
                            <Save size={16} />
                            <span>Save Issue</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}

                {/* Issues Table */}
                <div className="issues-table-container">
                  <table className="issues-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Issue</th>
                        <th>Month/Year</th>
                        <th>Add Issue Details</th>
                        <th>View Issue</th>
                        <th>Delete Issue</th>
                        <th>No. Of Articles</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(volume.issues || []).map((issue, index) => (
                        <React.Fragment key={issue.id}>
                          <tr className="issue-row">
                            <td>{index + 1}</td>
                            <td>Issue {issue.issue}</td>
                            <td>{issue.monthYear}</td>
                            <td>
                              <button
                                className="btn-add-details"
                                onClick={(e) => {
                                  e.stopPropagation();

                                  if (expandedIssue === issue.id && showArticleForm) {
                                    // close form
                                    setExpandedIssue(null);
                                    setShowArticleForm(false);
                                    setCurrentVolumeId(null);
                                    setCurrentIssueId(null);
                                  } else {
                                    // open form
                                    setCurrentVolumeId(volume.id);
                                    setCurrentIssueId(issue.id);
                                    setShowArticleForm(true);
                                    setExpandedIssue(issue.id);
                                  }
                                }}
                              >
                                <Plus size={14} />
                                <span>Add</span>
                              </button>
                            </td>
                            <td>
                              <button
                                className="btn-view"
                                onClick={(e) => {
                                  e.stopPropagation();

                                  if (expandedIssue === issue.id && !showArticleForm) {
                                    // close table
                                    setExpandedIssue(null);
                                  } else {
                                    // open table
                                    setShowArticleForm(false);
                                    setExpandedIssue(issue.id);
                                  }
                                }}
                              >
                                <Eye size={14} />
                                <span>View</span>
                              </button>
                            </td>
                            <td>
                              <button
                                className="delete-btn"
                                onClick={() => handleDeleteIssue(volume.id, issue.id)}
                              >
                                <Trash2 size={14} />
                              </button>
                            </td>
                            <td> <span className='issue-count'>{issue.articles?.length > 1 ? `${issue.articles?.length} Articles` : `${issue.articles?.length} Article`}</span></td>
                          </tr>

                          {/* Articles Section */}
                          {expandedIssue === issue.id && (
                            <tr className="articles-row">
                              <td colSpan="7">
                                <div className="articles-section">
                                  <h5>Articles in Issue {issue.issue}</h5>

                                  {showArticleForm &&
                                    currentVolumeId === volume.id &&
                                    currentIssueId === issue.id && (
                                      <div className="article-form-card">
                                        <div className="form-header">
                                          <h6>Add Article - Volume {volume.volume}, Issue {issue.issue}</h6>
                                          <button
                                            className="btn-icon"
                                            onClick={() => {
                                              setShowArticleForm(false);
                                              setCurrentVolumeId(null);
                                              setCurrentIssueId(null);
                                            }}
                                          >
                                            <X size={14} />
                                          </button>
                                        </div>

                                        <div className="article-form">
                                          <div className="form-group">
                                            <label>
                                              <FileText size={12} />
                                              <span>Topic <span className="required">*</span></span>
                                            </label>
                                            <input
                                              type="text"
                                              name="topic"
                                              value={articleForm.topic}
                                              onChange={handleArticleInputChange}
                                              placeholder="Article title"
                                            />
                                          </div>

                                          <div className="form-row">
                                            <div className="form-group">
                                              <label>
                                                <FileText size={12} />
                                                <span>Pages <span className="required">*</span></span>
                                              </label>
                                              <input
                                                type="text"
                                                name="pages"
                                                value={articleForm.pages}
                                                onChange={handleArticleInputChange}
                                                placeholder="e.g., 45-58"
                                              />
                                            </div>

                                            <div className="form-group">
                                              <label>
                                                <User size={12} />
                                                <span>Author <span className="required">*</span></span>
                                              </label>
                                              <input
                                                type="text"
                                                name="author"
                                                value={articleForm.author}
                                                onChange={handleArticleInputChange}
                                                placeholder="Author name"
                                              />
                                            </div>
                                          </div>

                                          <div className="form-group">
                                            <label>
                                              <Upload size={12} />
                                              <span>Upload File  (.doc, .docx, pdf)<span className="required">*</span></span>
                                            </label>
                                            <input
                                              type="file"
                                              onChange={handleFileChange}
                                              className="file-input"
                                              accept=".pdf,.doc,.docx"
                                            />
                                            {selectedFile && (
                                              <span className="file-name">{selectedFile.name}</span>
                                            )}
                                          </div>

                                          <div className="form-actions">
                                            <button
                                              className="btn-secondary"
                                              disabled={saving}
                                              onClick={() => {
                                                setShowArticleForm(false);
                                                setCurrentVolumeId(null);
                                                setCurrentIssueId(null);
                                              }}
                                            >
                                              Cancel
                                            </button>
                                            <button
                                              className="btn-primary"
                                              onClick={() => handleArticleSubmit(volume.id, issue.id)}
                                              disabled={saving}
                                            >
                                              {/* <Save size={12} /> */}
                                              {/* <span>Save Article</span> */}
                                              {saving ? (
                                                <>
                                                  <Loader2 size={16} className="spin-icon" />
                                                  <span>Saving...</span>
                                                </>
                                              ) : (
                                                <>
                                                  <Save size={16} />
                                                  <span>Save Article</span>
                                                </>
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                  {!showArticleForm && (
                                    issue.articles.length > 0 ? (
                                      <table className="articles-table">
                                        <thead>
                                          <tr>
                                            <th>Topic</th>
                                            <th>Pages</th>
                                            <th>Author</th>
                                            <th>File</th>
                                            <th>Delete</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {issue.articles.map((article) => (
                                            <tr key={article.id}>
                                              <td>{article.topic}</td>
                                              <td>{article.pages}</td>
                                              <td>{article.author}</td>
                                              <td>
                                                <button
                                                  className="btn-view-file"
                                                  onClick={() => handleViewArticle(article)}
                                                >
                                                  <Eye size={12} />
                                                  <span>View</span>
                                                </button>
                                              </td>
                                              <td>
                                                <button
                                                  className="btn-delete"
                                                  onClick={() => handleDeleteArticle(volume.id, issue.id, article.id)}
                                                >
                                                  <Trash2 size={14} />
                                                </button>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : (
                                      <p className="no-articles">No articles in this issue</p>
                                    )
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {showArticleModal && selectedArticle && (
        <div className="modal-overlay" onClick={() => setShowArticleModal(false)}>
          <div className="article-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Article Details</h3>
              <button className="btn-icon" onClick={() => setShowArticleModal(false)}>
                <X size={18} />
              </button>
            </div>

            <div className="modal-body">
              <div className="detail-row">
                <span className="detail-label">Topic:</span>
                <span className="detail-value">{selectedArticle.topic}</span>
              </div>

              <div className="detail-row">
                <span className="detail-label">Pages:</span>
                <span className="detail-value">{selectedArticle.pages}</span>
              </div>

              <div className="detail-row">
                <span className="detail-label">Author:</span>
                <span className="detail-value">{selectedArticle.author}</span>
              </div>

              <div className="detail-row">
                <span className="detail-label">File:</span>
                <span className="detail-value">{selectedArticle.file}</span>
              </div>

              {/* <div className="detail-row">
                <span className="detail-label">File Size:</span>
                <span className="detail-value">{selectedArticle.fileSize}</span>
              </div> */}
            </div>

            <div className="modal-footer">
              <button className="btn-secondary" onClick={() => setShowArticleModal(false)}>
                Close
              </button>
              <button className="btn-primary"
                onClick={() => handleDownloadFiles(selectedArticle.file)}

              >
                <Download size={14} />
                <span>Download</span>
              </button>
            </div>
          </div>
        </div>
      )}

      {toast.show && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, show: false })}
        />
      )}
    </div>
  );
};

export default JournalVolume;
